<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">{{ stepDetails?.name }}</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span
            class="badge"
            [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }"
          >
            {{
              stepDetails?.step_status == 0
                ? "PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>
       

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i>Save/Forward/Route Config
          </button>
        </ng-container>

        
      </div>
    </div>
  </div>
  <hr class="my-3" />

  <!-- Vendor Management Section -->
  <app-vendor-management
  *ngIf="!hideVendorManagement"
    [stepDetails]="stepDetails"
    [schemeType]="schemeType || 'rev'"
    [format]="'upload'"
    [url]="'/revenue/dms-file/vendor/'"
    [proposalStepId]="stepDetails?.id || step?.id"
    [proposalId]="stepDetails?.proposal || payload?.proposal_id"
    (vendorAdded)="onVendorAdded($event)"
    (vendorUpdated)="onVendorUpdated($event)"
    (vendorDeleted)="onVendorDeleted($event)"
    (filesSubmitted)="onFilesSubmitted($event)"
  ></app-vendor-management>
 
  <div class="mb-4">

    
    <app-upload-document [title]="stepDetails.name+'Document'" [isEditable]="stepDetails?.can_edit"> </app-upload-document>
  <form [formGroup]="commentForm" class="proposal-form-container mt-4">
      <div class="form-container">
          <div class="editor-field" >
            <p class=" bg-primary text-white p-2 ">
              {{ stepDetails.name }} MoM
            </p>
            <editor [init]="init" formControlName="justification" [disabled]="isEditorDisabled"></editor>
          </div>
        </div>
        
      </form>
</div>
